import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { Pie, Bar } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { getItemPowerMetrics } from '../../components/deityRequests';

const ItemPowerMetrics = () => {
    const [metrics, setMetrics] = useState([]);
    const [pieLabels, setPieLabels] = useState(["ItemOwnership", "Roleplay", "ItemPower"]);
    const [pieData, setPieData] = useState([10, 10, 10]);
    const [pieColours, setPieColours] = useState([
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(54, 235, 60, 0.2)',
    ]);

    useEffect(() => {
        getMetrics();
    }, []);

    const getMetrics = async () => {
        let data = await getItemPowerMetrics();
        if (data.result) {
            setMetrics(data.metrics);
            let newLabels = [];
            let newData = [];
            let newColours = [];
            data.metrics.filter(M => M.count > 0).map(metric => {
                newColours = [...newColours, getColourFromRange(metric.range)];
                newLabels = [...newLabels, metric.range];
                newData = [...newData, metric.count];

            });
            setPieLabels(newLabels);
            setPieData(newData);
            setPieColours(newColours);


        } else {
            setMetrics([]);
        }
    }

    const getColourFromRange = (range) => {
        let values = range.replace("[", "").replace(")", "").split(",");
        console.log(values);

        if (values[1] <= 50) {
            return 'rgba(54, 235, 226, 0.8)';
        } else if (values[1] <= 100) {
            return 'rgba(54, 235, 226, 0.4)';
        } else if (values[1] <= 150) {
            return 'rgba(54, 235, 60, 0.8)';
        } else if (values[1] <= 200) {
            return 'rgba(54, 235, 60, 0.4)';
        } else if (values[1] <= 250) {
            return 'rgba(54, 235, 60, 0.2)';
        } else if (values[1] <= 300) {
            return 'rgba(255, 255, 0, 0.8)';
        } else if (values[1] <= 400) {
            return 'rgba(255, 100, 0, 0.8)';
        } else {
            return 'rgba(255, 0, 0, 0.8)';

        }
    }

    const data = {
        labels: pieLabels,
        datasets: [
            {
                data: pieData,
                backgroundColor: pieColours,
                borderWidth: 1,
            },
        ],
    };

    const barData = {
        axis: 'y',
        labels: pieLabels,
        datasets: [
            {
                axis: 'y',
                data: pieData,
                backgroundColor: pieColours,
                borderWidth: 1,
            },
        ],
    };

    return (
        <>
            <Pie data={data} />
            <Bar data={barData} options={{
                indexAxis: 'y'
            }} />
        </>);
}

export default ItemPowerMetrics;